<template>
  <el-container v-if="profile" class="dashboard">
    <el-aside class="dashboard__aside">
      <el-header class="dashboard__header">
        <h1 class="app__title">Видеоконтроль</h1>
      </el-header>
      <side-menu />
    </el-aside>
    <el-container class="dashboard__container">
      <el-header class="dashboard__header dashboard__header--right">
        <el-button class="profile" type="text" @click="goProfile">{{ profile.client_name }}</el-button>
        <el-button class="logout" id="logout" type="text" @click="logout">Выйти</el-button>
      </el-header>
      <router-view />
    </el-container>
  </el-container>
</template>

<script>
import SideMenu from "@/components/SideMenu/index";
import { mapState, mapMutations } from "vuex";
import OperatorService from "@/api/services/operator.service";
export default {
  name: "Dashboard",
  components: { SideMenu },
  computed: {
    ...mapState("profile", ["profile"]),
    ...mapState("profile", { profileLoading: (state) => state.loading }),
  },
  methods: {
    ...mapMutations("auth", { setToken: "SET_TOKEN" }),
    ...mapMutations("profile", { setProfile: "SET_PROFILE" }),
    logout() {
      this.setToken(null);
      this.setProfile(null);
      OperatorService.removeOperatorId();
      this.$router.push({ name: "login" });
    },

    goProfile() {},
  },
};
</script>

<style>
.dashboard__aside {
  height: 100vh;
  min-width: 300px;
}

.dashboard__header {
  background-color: #edf2fc;
  line-height: 60px;
}
.dashboard__header--right {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.dashboard .profile {
  margin-right: 15px;
}
.dashboard .logout {
  line-height: 36px;
}
.page__container {
  width: 100%;
  height: calc(100vh - 120px);
  padding: 20px;
  box-sizing: border-box;
  overflow: auto;
}
.el-main.page__container > .container {
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  margin: -20px;
  padding: 20px;
}
.page__form {
  margin: 10px 0 0 0;
}
.page__active_bar {
  background-color: #edf2fc;
}
.page__active_button {
  float: right;
  margin-top: 11px;
  margin-left: 11px;
}
.page__active_button--left {
  float: left;
  margin-top: 11px;
  margin-right: 11px;
}
.delimiter {
  border: 1px solid #edf2fc;
}
.el-table .cell {
  word-break: break-word;
}
.link {
  line-height: 1;
  cursor: pointer;
  outline: 0;
  margin: 0;
  transition: 0.1s;
  color: #409eff;
}

.el-form {
  max-width: 1000px;
}
</style>
